import * as types from 'modules/notifications/actionTypes';
import { uniq } from 'utils/ObjectUtils';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {Array<string>} State */
const initialState = [];

const add = (state, { payload }) => uniq([...(payload.notifications?.map(({ id }) => id) ?? []), ...state]);

const deleteOne = (state, { payload }) => state.filter(id => id !== payload);

const update = (state, { payload }) => uniq([...state, ...(payload.notifications?.map(({ id }) => id) ?? [])]);

const clear = () => [];

export default createReducer(initialState, {
  [types.ADD]: add,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS]: update,
  [types.DELETE_NOTIFICATION_SUCCESS]: deleteOne,
  [types.RESET_NOTIFICATIONS_DASHBOARD]: clear,
});
